export class TypeMarcheReserve {

	public structureInsertion: string;

	public entrepriseAdaptee: string;

	public servicesSociaux: string;

	constructor() { 
		 		this.structureInsertion = '';
		this.entrepriseAdaptee = '';
		this.servicesSociaux = '';
 
	}
}
